var defaultValues = JSON.parse(localStorage.getItem('memory') || '{}')

export default {

	namespaced: true,

	state: {

		data: defaultValues

	},

	getters: {

		get: function(state) {

			return state.data

		}

	},

	mutations: {

		add: function(state, e) {

            state.data[e.name] = e.value
            
            localStorage.setItem('memory', JSON.stringify(state.data))

		},

		set: function(state, value) {

			state.data = value
            
            localStorage.setItem('memory', JSON.stringify(state.data))

		},

		delete: function(state, name) {

			delete state.data[name]
            
            localStorage.setItem('memory', JSON.stringify(state.data))

		}

	}

}